import { render, staticRenderFns } from "./sport-text-intro.vue?vue&type=template&id=a898e5b2&scoped=true"
import script from "./sport-text-intro.vue?vue&type=script&lang=js"
export * from "./sport-text-intro.vue?vue&type=script&lang=js"
import style0 from "./sport-text-intro.vue?vue&type=style&index=0&id=a898e5b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a898e5b2",
  null
  
)

export default component.exports